import React from 'react';
import classNames from 'classnames';
import styles from './ContextMenuItem.scss.js';
import { contextMenuIconsMap } from '../../ContextMenu/ContextMenu.shared.js';
import HotKeyController from './HotKeyController/HotKeyController.js';
import { getHotKeyText, isAppleOs } from '../../../../../helpers/hotkey/hotKeyHelper.js';
import Icon from '../../../../Icons/Icons/Icon/Icon.js';

const ContextMenuItem = _ref => {
  let {
    item,
    keyScope
  } = _ref;
  const {
    text,
    iconKey,
    disabled = false,
    onClick,
    hotKey
  } = item;
  const iconName = iconKey && (disabled ? contextMenuIconsMap[iconKey].disabled : contextMenuIconsMap[iconKey].default);
  const hotkeyText = !hotKey ? '' : getHotKeyText(hotKey);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!hotKey && keyScope && /*#__PURE__*/React.createElement(HotKeyController, {
    hotKey: isAppleOs() && hotKey.mac ? hotKey.mac : hotKey.default,
    handleAction: onClick,
    enabled: !disabled,
    keyScope: keyScope
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    "aria-label": `Option for ${text}`,
    disabled: disabled,
    className: classNames(styles.container, {
      [styles['container--two-column']]: !!hotkeyText,
      [styles['container--disabled']]: disabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container__content
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    icon: iconName
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.container__content__text
  }, text)), hotkeyText && /*#__PURE__*/React.createElement("p", {
    className: styles['container__hot-key-text']
  }, hotkeyText)));
};
var ContextMenuItem$1 = ContextMenuItem;

export { ContextMenuItem$1 as default };
//# sourceMappingURL=ContextMenuItem.js.map
